import { https } from "../http";
import store from "../store";
import { setActivities, setLoading, setSaving } from "../store/reducers/activityLibrary";
import { showError } from "../utils/index";

// GET
const getActivityLibrary = async (showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get("/activity-library");

    if (response?.status === 200) {
      store.dispatch(setActivities(response?.data?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// POST
const createActivityLibraryItem = async (data, callback) => {
  try {
    store.dispatch(setSaving(true));
    let response = await https().post("/activity-library", data);

    if (response?.status === 200) {
      store.dispatch(setSaving(false));
      getActivityLibrary(false);
      callback?.();
    }
  } catch (error) {
    store.dispatch(setSaving(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// PUT
const editActivityLibraryItem = async (data, callback) => {
  try {
    store.dispatch(setSaving(true));
    let response = await https().put("/activity-library", data);

    if (response?.status === 200) {
      store.dispatch(setSaving(false));
      getActivityLibrary(false);
      callback?.();
    }
  } catch (error) {
    store.dispatch(setSaving(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const toggleActivityLibraryStatus = async (id, active) => {
  try {
    let response = await https().put("/activity-library/status", { id, active });

    if (response?.status === 200) {
      getActivityLibrary(false);
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// DELETE
const deleteActivityLibraryItem = async (id, callback) => {
  try {
    let response = await https().delete(`/activity-library?id=${id}`);

    if (response?.status === 200) {
      getActivityLibrary(false);
      callback?.();
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export {
  getActivityLibrary,
  createActivityLibraryItem,
  editActivityLibraryItem,
  toggleActivityLibraryStatus,
  deleteActivityLibraryItem,
};
